<!-- <app-breadcrumb [title]='"Country main menu"| translate' [items]="['Tables', 'Bootstrap Tables']" [active_item]="'Basic'"></app-breadcrumb> -->
<div class="container-fluid">
 <div class="row">
  <div class="col-sm-12">
   <div class="card">


    <div class="card-header" style="padding-bottom: 5px !important">
     <div class="row">
      <div class="col-6  "><!-- <h5 class="pb-2">تعديل المهنه موجود</h5> -->
       <h5 class="pb-2">القائمة الرئيسية للحملة </h5>
       <!-- يمكنك تعديل المهنه  فى القائمة  -->


      </div>

      <div class="col-6 header-titles"> <a routerLink="/content/admin/insert-Campaign" class="d-block">
        <button class="btn  pull-right" type="button">
         <span class="m-2">إضافة جديدة</span> <i class="fa fa-plus"></i>
        </button>
       </a>

      </div>
     </div>

    </div>




    <div class="card-block row">
     <div class="col-sm-12 col-lg-12 col-xl-12">
      <div class="table-responsive">
       <table class="table table-responsive-sm">
        <thead>
         <tr class=" ">
          <th scope="col"></th>
          <th scope="col">الاسم</th>
          <th scope="col"> الوصف</th>
          <th scope="col">صورة</th>
          <th scope="col">الحالة</th>
          <th scope="col"> </th>
         </tr>
        </thead>
        <tbody>
         <tr *ngFor="let item of response; let i = index; trackBy: track" class=" ">

          <td scope="row">{{i+1 }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.description }}</td>
          <td class="avatar ratio">
           <img class="img-50 " [src]="img+item.image" />
          </td>
          <td>
            <span *ngIf="!item.inactive">نشط</span>
            <span *ngIf="item.inactive">غير نشط</span>
          </td>
          <td class="font-style chose"> <button class="btn  pull-right" (click)="Delete(item.id)"
            style="color: red; padding: 7px">
            <i class="fa fa-trash"></i>

           </button>

           <button class="btn  pull-right" style="color: rgba(35, 118, 241, 0.667); padding: 7px"
            (click)="Update(item.id)">
            <i class="fa fa-pencil"></i>
           </button>
          </td>
         </tr>

        </tbody>
       </table>

      </div>
     </div>
    </div>


   </div>
  </div>
 </div>
 <div class="row justify-content-center w-100">
  <div class="d-flex justify-content-center">
   <pagination [boundaryLinks]="true" [maxSize]="5" [totalItems]="totalCount"
       previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
       [itemsPerPage]="pager.maxResultCount" [(ngModel)]="pageNumber"
       (pageChanged)="pageChanged($event)">
   </pagination>
</div>
 </div>
</div>